<div class="container">
    <div class="row">
        <div class="col-12 col-md-4">
            <img class="login-logo" src="/img/LOGOpimeo.png" />
        </div>
        <div class="col-12 col-md-8">
            <form
                class="formly form login-form"
                role="form"
                validate
                [formGroup]="form"
                (ngSubmit)="submit()"
            >
                <formly-form
                    [model]="login"
                    [fields]="loginFields"
                    [form]="form">
                </formly-form>
                <button
                    type="submit"
                    class="btn pimeo-blue"
                    [disabled]="form.invalid || forceDisable">
                    LOGIN
                </button>
            </form>
        </div>
    </div>
</div>

<client-switcher
    #clientSwitcher
    (onSelect)="redirectFromLogin()"
    [backdrop]="'static'"
></client-switcher>
